export interface ServiceDiscount {
  active: boolean;
  price: number;
  until: string;
  name?: string;
}

const todayIso = () => new Date().toISOString().slice(0, 10);

export function isDiscountActive(service: any, today: string = todayIso()): boolean {
  const d: ServiceDiscount | undefined = service?.discount;
  return !!d?.active && !!d.until && d.until >= today && d.price >= 0 && d.price < (+service.price || 0);
}

export function effectivePrice(service: any): number {
  return isDiscountActive(service) ? +service.discount.price : +service?.price || 0;
}

// Campi da copiare sulla riga evento quando il servizio ha uno sconto attivo
export function discountFields(service: any): { full_price?: number; discount_name?: string } {
  if (!isDiscountActive(service)) return {};
  return { full_price: +service.price || 0, discount_name: service.discount.name ?? '' };
}
